"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import Link from "next/link";

const NotFound = () => {
  const pathname = usePathname();
  const { t } = useLanguage();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", pathname);
  }, [pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold">404</h1>
        <p className="mb-4 text-xl text-muted-foreground">{t.common.pageNotFound}</p>
        <Link href="/" className="text-primary underline hover:text-primary/90">
          {t.common.returnToHome}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
